/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateJobStatusQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("TemplateJobStatusQueryOperator");
    }

    getFixupPrototypeFunction() { return TemplateJobStatusQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<TemplateJobStatusQueryOperator>): TemplateJobStatusQueryOperator {
        let obj = Object.assign(new TemplateJobStatusQueryOperator(), model);
        TemplateJobStatusQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateJobStatusQueryOperator>): TemplateJobStatusQueryOperator {
        if (!model) return null;
        return TemplateJobStatusQueryOperator.newInstance(<TemplateJobStatusQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateJobStatusQueryOperator) {
        if (!obj) return;

        models.TemplateJobStatusQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateJobStatusQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateJobStatusQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template job statuses to include
     */
    statuses: Array<models.TemplateJobStatus>;

}
